import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  inject,
  Inject,
  signal,
  WritableSignal,
  computed,
  effect,
} from '@angular/core';
import { CoreService } from 'src/app/core/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgForOf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrandingComponent } from '../sidebar/branding.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { KeycloakService } from 'keycloak-angular';
import { AuthState } from 'src/app/core/models/auth.model';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';
import { NotificationFluxService } from './notification-flux.service';
import { combineLatest, filter, firstValueFrom, interval, map, Observable, skip, switchMap, timeInterval } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { Notifications } from './notification.model';
import { AppNavItemComponent } from '../sidebar/nav-item/nav-item.component';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AreraService } from 'src/app/pages/psa/services/arera.service';
import { WaterSupplyCompanyService } from 'src/app/pages/psa/services/water-supply-company.service';
import { CheckCompanyService } from 'src/app/core/services/check-company.service';



interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  styleUrls: ['./header.component.scss'],
  imports: [RouterModule, CommonModule, NgScrollbarModule, TablerIconsModule, MaterialModule, BrandingComponent],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  navItems = navItems.filter((navitem) => navitem.displayName);
  showFiller = false;
  notifications:Notifications[];
  intervalId: any;
  user:any;
  user$ = toObservable(this.authStore.selectKey('user'));
  reloadTrigger = signal(false);
  reloadTrigger$ = toObservable(this.reloadTrigger);
  userLoaded = false;
  waterSupplyCompanies = toSignal<any>(this.reloadTrigger$.pipe(
    switchMap(() => this.wscService.getAllWaterSupplyCompanies()),
    map( (res: any) => res?.data ?? [])
    )
  );
  selectedCompany = signal<any>('');
  waterSupplyCommpanySelected = computed(() =>
     this.waterSupplyCompanies()?.find((waterSupplyCompany: any) => waterSupplyCompany.active) ?? ''
  );

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: './assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: './assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: './assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: './assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: './assets/images/flag/icon-flag-de.svg',
    },
  ];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private authService: AuthService,
    private keycloakService: KeycloakService,
    private router : Router,
    private loaderService: LoaderService,
    private notificationFluxService: NotificationFluxService,
    private wscService: WaterSupplyCompanyService,
    private areraService: AreraService,
    private checkCompanyService: CheckCompanyService,

    @Inject('auth-store') private readonly authStore = inject(SignalStore<AuthState>)
  ) {
    translate.setDefaultLang('en');


    effect(() => {
      const selected = this.waterSupplyCommpanySelected();
      this.checkCompanyService.setSelectedCompany(selected);
    });

  }

  ngOnInit(){
    this.authService.userLoaded$.subscribe(loaded => {
      this.user = this.authStore?.selectKey("user")()
      this.userLoaded = loaded;
    });
    this.notificationFluxService.query.get({ pageable: { size: 5 }, filters : 'read||eq||false'});
    this.intervalId = setInterval(() => {
      this.notificationFluxService.query.get({ pageable: { size: 5 }, filters : 'read||eq||false'});
    }, 30000);
/*     this.getNotification()
    this.intervalId = setInterval(() => {
      this.getNotification();
    }, 30000); */

  }

  get notificheUtente(){
    return this.notificationFluxService.query.list(); // Ora si aggiornerà automaticamente!
  }

  get numeroNotifiche(){
   // return this.notificationFluxService.query.store.selectKey('pageable')
    return this.notificationFluxService.query.pageable()
  }
  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

/*   getNotification(){

    this.notificationFluxService.getAll({pageIndex : 0 , pageSize: 5},'read||eq||false', '').subscribe((el:any)=>{
      if(el.data.meta.totalItems>0){
        this.numeroNotifiche=el.data.meta.totalItems
        this.notifications=el.data.data
      }
    });
  }
   */

  logout(){
    this.authService.logout()
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }
  goDetailNotifica(id:number | string){
    this.router.navigate(['/lista-notifiche/'+id])
  }

  async switchWaterSupplyCompany(id: number) {
    await firstValueFrom(this.areraService.switchWaterSupplyCompany(id))
    .then(() => {this.reloadTrigger.update(r => !r);location.href = 'dashboard';});
  }


  profiledd: profiledd[] = [
/*     {
      id: 1,
      img: './assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: './assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: './assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/apps/taskboard',
    }, */
  ];

  openHelp() {
    this.router.navigate(['/help/'])
  }
}

@Component({
  selector: 'search-dialog',
  standalone: true,
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule,
    NgForOf,
  ],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  constructor(  ){}
  navItemsData = navItems.filter((navitem) => navitem.displayName);

}

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
